import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { CARBON_OFFSET_PORTFOLIOS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchPortfolios = () => {
  return useQuery({
    queryKey: [CARBON_OFFSET_PORTFOLIOS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/portfolios",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
